import React, {ReactElement} from "react"

import styles from "../../styles/home/TwoColumnInfoSection.module.scss"

type DescriptionElement = string|ReactElement
type Description = DescriptionElement|(DescriptionElement)[]

export interface InfoItemProps {
  title?: string,
  subTitle?: string,
  imgSrc?: string,
  imgAlt?: string,
  description?: Description
}

export interface Props {
  items: InfoItemProps[]
  // TODO children: InfoItemPropChildElementThingy - would be cool, maybe not useful
  //      let the user define the item props via elements instead of json
}

function renderDescriptionItem(item:DescriptionElement, i:number=0):ReactElement {
  if (typeof item === "string") {
    return <p key={i}>{item}</p>
  }
  else {
    return item
  }
}

function renderDescription(description:Description = []):ReactElement {
  let children:ReactElement[]
  if (Array.isArray(description)) {
    children = description.map(renderDescriptionItem)
  }
  else {
    children = [renderDescriptionItem(description)]
  }
  return (
    <div className={styles.description}>
      {children}
    </div>
  )
}

function renderItem({title, subTitle, imgSrc, imgAlt, description}:InfoItemProps, i:number): ReactElement {
  const hasTitle = title !== undefined
  const hasSubTitle = subTitle !== undefined
  const hasImg = imgSrc !== undefined && imgAlt !== undefined
  return (
    <div className={styles.infoItem} key={i}>
      {hasImg? <img loading="lazy" src={imgSrc} alt={imgAlt} /> : undefined }
      {hasTitle? <h3 className={styles.title}>{title}</h3> : undefined }
      {hasSubTitle? <h4 className={styles.subTitle}>{subTitle}</h4> : undefined }
      {renderDescription(description)}
    </div>
  )
}

export function TwoColumnInfoSection({items}:Props): ReactElement {
  return (
    <div>
      <h2 className={styles.twoColumnSubheader}>Testimonials</h2>
      <div className={styles.twoColumnInfoSection}>
        {items.map(renderItem)}
      </div>
    </div>
  )
}